import { PropsWithChildren } from 'react';
import { Element, useNode } from '@craftjs/core';
import { theme } from '@frontend/theme';
import { FooterSection } from '../../parts/footer-section/footer-section';
import { useContentComposer } from '../content-composer-provider';
import { EmptyState } from './empty-state';

type Props = PropsWithChildren<{
  emptyStateSubTitle: string;
  emptyStateTitle: string;
}>;

// TODO: Figure out how to pass an empty state, which may include SectionComponents (like the FooterSection), to the Designer
export const Designer = ({ children, emptyStateSubTitle, emptyStateTitle }: Props) => {
  const { composerMode } = useContentComposer();
  const {
    connectors: { connect, drag },
  } = useNode();

  const hideDefaultFooter = composerMode === 'feedback';

  return (
    <div
      className='composer-designer'
      css={[
        {
          alignContent: 'center',
          alignSelf: 'stretch',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden auto',
          padding: theme.spacing(8, 5),
        },
        !children && {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      ]}
      ref={(ref) => (ref ? connect(drag(ref)) : null)}
    >
      {children ? children : <EmptyState subTitle={emptyStateSubTitle} title={emptyStateTitle} />}
      {hideDefaultFooter ? null : <Element id='footer' is={FooterSection} />}
    </div>
  );
};
